export const environment = {
  production: false,
  apiUrl: process.env.NX_API_HOST ?? 'http://localhost:8080',
  apiKey: process.env.NX_API_KEY ?? 'verySecureApiKey',
};
